import $foreign from "./foreign.cjs";
var arrayApply = $foreign.arrayApply;
export { arrayApply };
